/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Email = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 16">
      <path d="M19.49,0.94 C19.49,0.94 19.49,0.87 19.49,0.84 C19.4933027,0.810090896 19.4933027,0.779909104 19.49,0.75 C19.49,0.75 19.49,0.75 19.49,0.69 C19.49,0.63 19.49,0.69 19.49,0.69 L19.41,0.62 L19.34,0.62 L19.25,0.62 L19.15,0.62 L1,0.62 L0.9,0.62 L0.81,0.62 L0.74,0.68 L0.66,0.74 C0.66,0.74 0.66,0.74 0.66,0.74 C0.66,0.74 0.66,0.74 0.66,0.8 C0.656697341,0.829909104 0.656697341,0.860090896 0.66,0.89 C0.66,0.89 0.66,0.96 0.66,0.99 C0.66,1.02 0.5,1 0.5,1 L0.5,15 C0.5,15.2761424 0.723857625,15.5 1,15.5 L19,15.5 C19.2761424,15.5 19.5,15.2761424 19.5,15 L19.5,1 C19.5,1 19.49,1 19.49,0.94 Z M17.54,1.5 L10,7.37 L2.46,1.5 L17.54,1.5 Z M1.54,14.5 L1.54,2 L9.73,8.37 C9.91039538,8.51736891 10.1696046,8.51736891 10.35,8.37 L18.5,2 L18.5,14.5 L1.54,14.5 Z" />
    </BaseSvgIcon>
  )
}

export default Email
